import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { IrbSettingsEvents, IEvent } from '@irb/irb-common/events';
import { PageService } from '@irb/irb-common/services/page.service';
import { IrbOptionChainsService } from '@irb/irb-option-chains/irb-option-chains.service';
import { IOptionChainSelected, IrbOptionChains } from '@irb/irb-option-chains/irb-option-chains.model';
@Component({ standalone: false,
    selector: 'irb-create-securities-dialog',
    templateUrl: './create-securities-dialog.component.html',
    styleUrls: ['./create-securities-dialog.component.scss','../../irb-common/styles/dialog.scss'],
    providers: [],
    encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CreateSecuritiesDialogComponent implements OnInit, OnDestroy {
    @ViewChild('overlayComponent') private overlay: any;
  
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    _hasUnsavedChanges: boolean = false;
    closeAfterSave: boolean = false;
    eventSubscription: Subscription;
    clickTarget: HTMLElement;
    index: number;
    faWindowClose = faWindowClose;
    _isIntegrationsEnabled: boolean = false;
  
    private optionChainSubscription: Subscription;

    optionChainData: Array<IOptionChainSelected>;

    optionChainInput: IrbOptionChains;
  
    constructor(public dialogRef: MatDialogRef<CreateSecuritiesDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public eventData: any,
      public ps: PageService, 
      private as: AppService,
      private cdr: ChangeDetectorRef,
      private irbOptionChainsService: IrbOptionChainsService) {
        this.index = 0;
        this.optionChainSubscription = this.irbOptionChainsService.optionChainSymbolSelections$.subscribe((optionData) => this.optionChainSelected(optionData));
    }
  
    ngOnInit() { 
      this.optionChainInput = {
        chainType : 'ALL',
        isChainTypeDisable : false,
        isTrayVisible : true,
        canSelectMultiple: true
      };
    }
  
    
  
    ngOnDestroy() {
      this.destroyed$.next(true);
      this.destroyed$.complete();
      this.optionChainSubscription.unsubscribe();
      this.irbOptionChainsService.createSecurityBySymbolMultilineValues= null;
    }

    setMultiLineValues(event:any) {
      // console.log('mutliline values', event);
      this.irbOptionChainsService.createSecurityBySymbolMultilineValues = event;
    }

    private optionChainSelected(optionChainData: any) {
      //replace spaces with underscore
        if (optionChainData && Array.isArray(optionChainData)) {
            optionChainData.forEach((optionGroup: any) => {
                optionGroup[1].forEach((rawSymbol: string, index: number) => {
                    optionGroup[1][index] = rawSymbol.replace(/[ ]+/g, '_');
                });
            });
        }

      // console.log('From security dialog data is', optionChainData);
      this.optionChainData = optionChainData;
      this.index = 0;
    }
  
    close() {
      if(this.hasUnsavedChanges) {
        this.clickTarget = null;
        this.closeAfterSave = true;
        this.as.fireEvent(IrbSettingsEvents.UNSAVED_CHANGES);
      } else {
        this.dialogRef.close();
      }
    }
    
    closeOptionChain(isCancel?:boolean) {
      if (isCancel) {
        this.dialogRef.close();
      }
    }
  
    clickTargetFire() {
      if(this.clickTarget) {
        this.clickTarget.click();
        this.clickTarget = null;
        return true;
      } else {
        return false;
      }
    }
  
    save() {
      this.as.fireEvent(IrbSettingsEvents.SAVE);      }
  
    
  
    public get hasUnsavedChanges(): boolean {
      return this._hasUnsavedChanges;
    }
    
    public set hasUnsavedChanges(value: boolean) {
      this._hasUnsavedChanges = value;
    }
  
    public get isIntegrationsEnabled(): boolean {
      return this._isIntegrationsEnabled;
    }
  
    public set isIntegrationsEnabled(newValue: boolean) {
      this._isIntegrationsEnabled = newValue;
    }
  }
